// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"BottomNav_bottomNav__1cX2j"};